import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DropdownMenuData } from '@vg-constellation/angular-18/dropdown'
import {
  DropdownMenuItem,
  DropdownState,
} from '@vg-constellation/angular-18/dropdown/dropdown.component'
import {
  DateRangeHoldingResponse,
  PortfolioHoldingResponse,
} from 'src/app/models/portfolio-models/portfolio-holding-response.model'
import { MainService } from 'src/app/services/main.service'

@Component({
  selector: 'date-range-select',
  templateUrl: './date-range-select.component.html',
  styleUrls: ['./date-range-select.component.scss'],
})
export class DateRangeSelectComponent {
  constructor(private readonly mainService: MainService) {}
  @Input() dateRanges: DateRangeHoldingResponse
  @Output() dateRangedData = new EventEmitter<PortfolioHoldingResponse>()

  placeholderText: string
  menuData: DropdownMenuData
  menuDataGroupItem: DropdownMenuItem[] = []

  ngOnInit() {
    this.dateRanges.dateLabels[0].item.forEach((dateItem) => {
      this.menuDataGroupItem.push({
        labelText: dateItem.label,
        id: dateItem.date,
      })
    })
    this.menuData = { groups: [{ items: this.menuDataGroupItem }] }
    this.placeholderText = this.menuData?.groups[0]?.items[0]?.labelText
  }

  changeRange(event: DropdownState) {
    const dateRange = event.activeItems[0]
    this.mainService.getMoneyMarketByDateRange(dateRange).subscribe((data) => {
      this.dateRangedData.emit(data)
    })
  }
}
